/* eslint-disable react/no-danger */
import React from "react";
import classnames from "classnames";

// Components
import ContactDetailsBox from "../contact-details-box/ContactDetailsBox";

// Util
import getSolutionContent from "./util/getSolutionComponent";

// Styles
import styles from "./contact-us-delivery-solution.module.scss";

function ContactUsDeliverySolution({
  solution: { id, fields, buttonType, hierarchyPosition },
  className,
  contactMethods = {},
}) {
  const locationOnPage = hierarchyPosition.join(" | ");

  const SolutionComponent = getSolutionContent(id);
  const newDesign = !buttonType;

  return (
    <article
      className={classnames(styles.deliverySolution, styles.deliverySolution__inner, className)}
      data-solution-id={id}
    >
      <div className={styles.deliverySolution__content}>
        <SolutionComponent />
      </div>
      <ContactDetailsBox
        title={"We're here to help"}
        fields={fields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
        buttonType={buttonType}
        solutionId={id}
        location={locationOnPage}
        contactMethods={contactMethods}
        viewContactDetails={!newDesign}
        directlyDisplayContactMethods
      />
    </article>
  );
}

export default ContactUsDeliverySolution;
